import { extractBareIds } from '@openx/components-targeting/Targeting/AppInventory/utils/appGroupIds';
import { useMemo } from 'react';
import { useOptionsByPathQuery } from '../../../../hooks/useOptionsByPathQuery';
import { APP_GROUP_PATH, mapOptionsByPathToAppGroups } from './useAppGroupsFetch';

export const useResolveAppGroupIds = (appGroupVal: string | string[] | undefined) => {
  const bareIds = useMemo(() => extractBareIds(appGroupVal), [appGroupVal]);
  const idList = bareIds.join(',');

  const { data, loading } = useOptionsByPathQuery({
    variables: {
      path: APP_GROUP_PATH,
      filter: { id__in: idList },
    },
    skip: bareIds.length === 0,
    fetchPolicy: 'cache-first',
  });

  const appGroupsMap = useMemo(() => {
    const map = new Map<string, string>();
    for (const item of mapOptionsByPathToAppGroups(data?.optionsByPath)) {
      map.set(String(item.id), item.name);
    }
    return map;
  }, [data]);

  return { appGroupsMap, isLoading: loading };
};
